import { MaterialId } from '@core/constants/Material';
import FieldDimensionId from '@core/constants/FieldDimension';
import { ShoesCabinetId } from '@core/constants/Shape';
import {
    IDimensionUnit,
    IFormFieldDimension,
    IFormFieldMaterial,
    IFormFieldShapeQuantities,
    IFormInputType,
} from '../../../interfaces/Form';
import {
    allWoods,
    allMelamine,
    allMetals,
    getMaterialsWithExceptions,
} from './materialGroups';

export const fieldsShoesStoragesMaterial: IFormFieldMaterial = {
    material: {
        value   : undefined,
        options : getMaterialsWithExceptions([
            ...allWoods,
            ...allMelamine,
            ...allMetals,
        ],
        [
            MaterialId.BlackLocust,
            MaterialId.Iroko,
            MaterialId.Douglas,
            MaterialId.DouglasEngineered,
            MaterialId.DouglasRecycled,
            MaterialId.DouglasVeneer,
            MaterialId.Redcedar,
            MaterialId.RedcedarEngineered,
            MaterialId.RedcedarRecycled,
            MaterialId.RedcedarVeneer,
            MaterialId.Larch,
            MaterialId.LarchEngineered,
            MaterialId.LarchRecycled,
            MaterialId.LarchVeneer,
            MaterialId.Padouk,
            MaterialId.PadoukRecycled,
            MaterialId.PadoukEngineered,
            MaterialId.PadoukVeneer,
            MaterialId.Ipe,
            MaterialId.IpeRecycled,
            MaterialId.IpeEngineered,
            MaterialId.IpeVeneer,
            MaterialId.Garapa,
            MaterialId.Rust,
            MaterialId.Iron,
            MaterialId.ThermoLaqueredBlack,
            MaterialId.ThermoLaqueredWhite,
            MaterialId.SheetMetal,
            MaterialId.StainlessSteel,
            MaterialId.Zinc,
            MaterialId.WroughtIron,
        ]),
        required: false,
    },
};

export const fieldsShoesStoragesDimension: IFormFieldDimension = {
    [FieldDimensionId.Length]: {
        value        : undefined,
        type         : IFormInputType.Range,
        unit         : IDimensionUnit.Centimeters,
        step         : 10,
        range        : { min: 200, max: 2500 },
        required     : true,
        defaultValue : 500,
    },
    [FieldDimensionId.Depth]: {
        value        : undefined,
        type         : IFormInputType.Range,
        unit         : IDimensionUnit.Centimeters,
        step         : 10,
        range        : { min: 100, max: 1000 },
        required     : true,
        defaultValue : 200,
    },
    [FieldDimensionId.Height]: {
        value        : undefined,
        type         : IFormInputType.Range,
        unit         : IDimensionUnit.Centimeters,
        step         : 10,
        range        : { min: 300, max: 2000 },
        required     : true,
        defaultValue : 500,
    },
};

export const fieldsShoesStoragesShoesQuantity: IFormFieldShapeQuantities = {
    [ShoesCabinetId.ShoesQuantity]: {
        value : undefined,
        min   : 0,
        max   : 30,
    },
};

export const fieldsShoesStoragesQuantity: IFormFieldShapeQuantities = {
    [ShoesCabinetId.ShoesLocker]: {
        value : undefined,
        min   : 0,
        max   : 30,
    },
};

